import { defineStore } from 'pinia';
import { ref } from 'vue';
import { Tab } from '@/enums/Tab';

export const useTabsStore = defineStore('tabs', {
    state: () => ({
        activeTab: ref(Tab.CATEGORY),
    }),
    getters: {
        getActiveTab(): Tab {
            return this.activeTab;
        },
    },
    actions: {
        setActiveTab(tab: Tab) {
            this.activeTab = tab;
        }
    },
});